<template>
    <div class="container bg" :class="{'mt-11' : !$mq.isDesktop()}">
        <div class="background" />

        <!--<div
            class="info-banner"
            v-if="!$mq.isDesktop() && orderStore.order"
            :style="$_appViewPosition_positionTop"
        >
            Piano {{ orderStore.order.plan.meals }} ricette per {{ orderStore.order.plan.people }} persone
        </div>-->

        <!--<div class="checkout-payoff content">
            <h1>{{ $t("components.checkout.payoff.title") }}</h1>
            <h2 class="subtitle center">{{ $t("components.checkout.payoff.subtitle") }}</h2>
        </div>-->

        <!--<checkout-verify-coverage v-if="orderStore.order" :open="!user"/>-->
        <div class="checkout-container flex flex-wrap">
            <div class="checkout-panel shadow-box">
                
                <auth
                    :user="user"
                />

                <section v-if="$mq.isDesktop() || (user && !user.email.includes('guest.quomi.it'))" id="checkout-subscription">
                    <div class="section-title" :data-step-number="[orderStore.status === 'confirmed' ? 0 : 2]">
                        <h2>
                            <span v-if='$mq.isDesktop()'>Modalità di consegna</span>
                            <span v-else>Consegna</span>
                        </h2>

                        <div
                            class="flex-right link-detail"
                            v-if="orderStore.status === 'confirmed' && $mq.isDesktop()"
                            @click="updateStatus('pending')"
                        >
                            {{ $t("components.checkout.subscription.link") }}
                        </div>
                    </div>

                    <template v-if="user && !user.email.includes('guest.quomi.it')">
                        <template v-if="orderStore.order">
                            <delivery-main 
                                v-if="orderStore.status !== 'confirmed'"
                                class="section-content"
                            >
                                <template
                                    v-slot:cta-global
                                    v-if="$mq.isDesktop()"
                                >
                                    <CTA
                                        :loading="stepStore.updating.subscription"
                                        :disabled="stepStore.loading.subscription"
                                        @click="stepSubscription()"
                                        :content="$t('components.checkout.subscription.button')"
                                    />
                                </template>
                            </delivery-main>

                            <div
                                class="section-content"
                                v-else
                            >
                                <div
                                    class="flex"
                                    v-if="!$mq.isDesktop()"
                                >
                                    <h4
                                        v-html="`Indirizzo`"
                                    />
                                    <div
                                        class="flex-right link-detail"
                                        @click="updateStatus('pending')"
                                    >
                                        {{ $t("components.checkout.subscription.link") }}
                                    </div>
                                </div>

                                <div v-if="address && delivery">
                                    <div>{{ delivery.name }}</div>
                                    <div v-if="$root.source === 'enel'">{{ $t("components.subscription_form.enel.message") }} {{ delivery.notes }}</div>
                                    <div v-show="$root.source !== 'enel'">
                                        <div>{{ address.name }}</div>
                                        <div>{{ address.street }}</div>
                                        <div>{{ address.zip_code }}, {{ address.city }}</div>
                                        <div>{{ $t("components.subscription_form.default.telephone") }}: {{ delivery.phone }}</div>
                                        <div v-if="delivery.notes">{{ $t("components.subscription_form.default.message") }}: {{ delivery.notes }}</div>
                                        <div>Data: {{ $_dates_readableDate(orderStore.order.date.delivery) }}</div>
                                        <div>Tipo di consegna: {{ isFP ? 'consegna punto di ritiro' : 'consegna a domicilio' }} {{timeRanges}}</div>
                                    </div>
                                </div>

                                <div v-else>
                                    <loading-spin
                                        :height='200'
                                    />
                                </div>
                            
                                <!--<shipment-select
                                    v-if="!$mq.isDesktop()"
                                />-->
                            </div>
                        </template>

                        <loading-spin
                            :height='200'
                            v-if="!loading['stop'] && !orderStore.order"
                        />
                    </template>
                </section>

                <div
                    v-if="$mq.isDesktop() || orderStore.status === 'confirmed'"
                    id="checkout-payment"
                >

                    <section v-if="orderStore.status === 'confirmed'">
                        <br>
                        <div class="coupon-detail-info">
                            <div
                                class="link-detail link-big-detail"
                                @click="$refs.couponSection.toggle()"
                            >
                                <b>{{ $t("components.payment.coupon_link") }}</b>
                            </div>

                            <add-coupon
                                ref="couponSection"
                                :order='orderStore.order'
                                :openedOnLoad='false'
                                :showLabel="false"
                            >
                                <div slot="label">{{ $t("components.payment.coupon_label") }}<br></div> 
                            </add-coupon>
                        </div>
                        <pellegrini />

                        <edenred />

                    </section>

                    <section>

                        <div
                            class="section-title"
                            data-step-number="3"
                        >
                            <h2>{{ $t("components.checkout.payment.title") }}</h2>
                        </div>

                        <div class="section-content" v-if="orderStore.status === 'confirmed'">

                            <payment-methods />


                           <!-- <subscription-recurring-change :compact="true" />-->

                            <div class="payment-button-line">
                                

                                <div v-if="$mq.isDesktop()">
                                    <CTA
                                        isWithLoader
                                        :content="$t('buttons.confirm_order')"
                                        @click="stepPayment()"
                                        :loading="stepPaymentStore.loading"
                                        :disabled="confirmButtonDisabled || stepStore.loading.subscription"
                                    />
                                </div>

                                <div class="icons">
                                    <img src="https://api.quomi.it/oldimg/sigillo-netcomm.png" class="netcomm" height='42'>
                                    <img src="https://api.quomi.it/oldimg/certificato-ssl2.png" alt='ssl' class="ssl" style='max-height:52px; width: auto'>
                                </div>

                                <div v-if="$mq.isDesktop()">
                                  <p class='gray conditions'>
                                      Confermando il tuo ordine dichiari di essere maggiorenne e di aver preso visione e accettato integralmente
                                      <router-link
                                        :to="{name: 'legal'}"
                                        target='_blank'
                                        class="link-detail"
                                        :title="$t('auth.checkbox.general_conditions')"
                                        v-html="`Condizioni generali di vendita`"
                                      />
                                      e la
                                      <router-link
                                        :to="{name: 'privacy-policy'}"
                                        class="link-detail"
                                        :title="$t('auth.checkbox.privacy')"
                                        target='_blank'
                                        v-html="`Privacy policy`"
                                      />
                                      di Quomi.</p>

                                  <p class="gray small-text">&#127795; Pianteremo un albero in partnership con “Eden Reforestation Projects” per ogni ordine che effettuerai sul nostro sito.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <div
                class="sidebar-panel"
                v-if="$mq.isDesktop() || orderStore.status === 'confirmed'"
                id="checkout-bill"
            >
                <div
                    is="CheckoutBill"
                    class="sidebar-panel_inner float"
                    :stop="loading['stop']"
                />
            </div>

                <div v-if="!$mq.isDesktop()" class="pa-5" >
                  <p class='gray conditions'>
                      Confermando il tuo ordine dichiari di essere maggiorenne e di aver preso visione e accettato integralmente
                      <router-link
                        :to="{name: 'legal'}"
                        target='_blank'
                        class="link-detail"
                        :title="$t('auth.checkbox.general_conditions')"
                        v-html="`Condizioni generali di vendita`"
                      />
                      e la
                      <router-link
                        :to="{name: 'privacy-policy'}"
                        class="link-detail"
                        :title="$t('auth.checkbox.privacy')"
                        target='_blank'
                        v-html="`Privacy policy`"
                      />
                      di Quomi.</p>

                  <p class="gray small-text">&#127795; Pianteremo un albero in partnership con “Eden Reforestation Projects” per ogni ordine che effettuerai sul nostro sito.</p>
                </div>
        </div>

        <template v-if="!$mq.isDesktop()">
            <div
                class="footer-bill"
                :style="$_appViewPosition_positionBottom"
            >
                <div
                    class="footer-bill-inside flex-vcenter"
                    v-if="orderStore.order && orderStore.order.prices"
                >
                    <div
                        class="flex flex-vcenter"
                    >
                        <div
                            class="tot-price"
                            :class="{ 'mobile': !$mq.isDesktop() }"
                            v-if="!elemInView"
                        >
                            <div
                                v-if="orderHasDiscount"
                                class="new-price"
                            >
                                <nobr>{{ orderStore.order.prices.net}} {{ $t("general.currency") }}</nobr>
                            </div>
                            <div
                                :class="{ 'old-price': orderHasDiscount }"
                            >
                                <nobr>
                                    <span
                                        v-if="orderHasDiscount"
                                        v-html="`invece di`"
                                    />
                                    <span
                                        :class="{ 'strike': orderHasDiscount }"
                                    >
                                        <span
                                            v-if="!orderHasDiscount"
                                        >
                                            <h3>Totale: <br></h3>
                                        </span>
                                            {{ orderStore.order.prices.gross }} {{ $t("general.currency") }}
                                    </span>
                                </nobr>
                            </div>
                        </div>

                        <div
                            v-if="!user"
                            class="flex-right"
                            v-html="`Consegna: gratuita`"
                        />

                        <CTA
                            :loading="stepStore.updating.subscription"
                            :disabled="stepStore.loading.subscription"
                            @click="stepSubscription()"
                            :content="`Prosegui`"
                            v-if="user && !user.email.includes('guest.quomi.it') && orderStore.status !== 'confirmed'"
                        />

                        <CTA
                            isWithLoader
                            :loading="stepPaymentStore.loading"
                            @click="stepPayment()"
                            :content="`Conferma`"
                            :disabled="stepStore.loading.subscription"
                            :class="{ disabled: confirmButtonDisabled }"
                            v-if="orderStore.status === 'confirmed'"
                        />
                    </div>
                </div>
            </div>
        </template>


        <general-error />
    </div>
</template>

<script type="text/javascript">

import { container } from '../../services/container'

import { scrollToElementId } from '../../assets/js/main'
import { gtc } from '../../assets/js/main'

import ShipmentSelect from '../Delivery/ShipmentSelect'
import DeliveryMain from '../Delivery/DeliveryMain'
import PaymentMethods from './PaymentMethods'
import GeneralError from './GeneralError'
import CheckoutBill from './CheckoutBill'
import MenuAlert from './MenuAlert'
import Checkbox from '../Checkbox'
import Auth from './Auth'

import { deliveryContainer } from '../../mixins/deliveryContainer'
import { dataLayer } from '../../mixins/gtc'
import SubscriptionRecurringChange from './SubscriptionRecurringChange'

import { Order } from '../../core/Order'


import { subscriptionStore } from '../../store/subscriptionStore'
import { stepPaymentStore } from '../../store/stepPaymentStore'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from '../../store/orderStore'
import { errorStore } from '../../store/errorStore'
import { plansStore } from '../../store/plansStore'
import { menuStore } from '../../store/menuStore' 
import { stepStore } from '../../store/stepStore'
import AddCoupon from './AddCoupon'
import Edenred from './Edenred'
import Pellegrini from './Pellegrini'

export default {
    components: {
        PaymentMethods,
        CheckoutBill,
        GeneralError,
        Checkbox,
        Auth,
        DeliveryMain,
        ShipmentSelect,
        AddCoupon,
        Edenred,
        Pellegrini,
        SubscriptionRecurringChange
    },

    mixins: [
        dataLayer,
        deliveryContainer
    ],

    data () {
        return {
            subscriptionStore: subscriptionStore.state,
            stepPaymentStore: stepPaymentStore.state,
            deliveryStore: deliveryStore.state,
            orderStore: orderStore.state,
            errorStore: errorStore.state,
            plansStore: plansStore.state,
            menuStore: menuStore.state,
            stepStore: stepStore.state,

            loading: {
                stop: false,
            },  

            controller: {
                paymentCheckbox: false
            },

            elemInView: false,

            recipesId: []
        }
    },

    watch: {        
        'subscriptionStore.subscriptionParams': {
            handler: function () {
                errorStore.removeMessage()
            },
            deep: true
        },

        'orderStore.status' () {
            this.hashHandler()
            this.scrollHandler()
        },

        'user' (newUser, oldUser) {
            if (this.user && this.user.isSubscribed()) {
                this.$router.push({name: 'flow-subscribed'})
                return
            }
            if (!this.user) {
                this.updateStatus('pending')
            }

            const loginExecuted = () => { return oldUser === null }
            const logoutExecuted = () => { return newUser === null }

            if (loginExecuted() || logoutExecuted()) {
                this.createNewOrder()
            }

            this.hashHandler()
            this.scrollHandler()

            if (this.user && this.user.order) {
                orderStore.state.order = new Order(this.user.order)
            }

            if (this.user && this.user.subscription) {
                subscriptionStore.state.subscription = this.user.subscription
            }
        },

        'menuStore.active': {
            handler () {
                menuStore.redirectHandler()
            },
            immediate: true
        }
    },

    computed: {
        user () {
            return this.$root.user
        },

        menu () {
            return this.menuStore.menu
        },

        orderHasDiscount () {
            return this.orderStore.order && this.orderStore.order.prices.discount > 0
        },

        confirmButtonDisabled () {
            var isLoading = this.loading['stop'] || this.stepPaymentStore.loading || this.stepStore.updating.subscription
            return isLoading
        },

        address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        sub () {
            return this.subscriptionStore.subscription
        },

        delivery () {
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +this.orderStore.order.id)
                && this.deliveryStore.deliveries.order.find(r => +r.attributes.target_id === +this.orderStore.order.id).attributes
        },

        timeRanges () {
            if (!this.deliveryStore.params.timeRange.start || !this.deliveryStore.params.timeRange.end) return ''
            return `(${this.deliveryStore.params.timeRange.start.slice(0, -3)} - ${this.deliveryStore.params.timeRange.end.slice(0, -3)})`
        },

        isFP () {
            return this.delivery
                && this.delivery.code
                && this.delivery.code.includes('FP')
        }
    },

    methods: {
        updateStatus (val) {
            orderStore.state.status = val
        },

        scrollHandler () {
            /*
            if (!this.$mq.isDesktop()) return
            this.$nextTick(() => {
                if (this.user && !this.user.email.includes('guest.quomi.it')) {
                    this.orderStore.status === 'confirmed'
                        ? scrollToElementId('section-shipment')
                        : scrollToElementId('checkout-subscription')
                }
            })*/
        },

        hashHandler () {
            let step = this.orderStore.status === 'confirmed' ? 3 : (this.user && !this.user.email.includes('guest.quomi.it') ? 2 : 1)
            history.replaceState(null, null, "#step-"+step)
            this.eventStep(step)
        },

        load () {


            return menuStore.loadCurrentMenu(orderStore.getWeekPlanId()).then(response => {
                // this.loadRecipes()
                return plansStore.loadPlans()
            })
        },

        loadRecipes () {
            this.recipesId = menuStore.getMenuPrio({ numberOfRecipes: this.getMeals() })
        },

        createNewOrder () {
            return this.createGuest()

            .then(response => {

                orderStore.state.order = (this.user && this.user.order) ? new Order(this.user.order) : null
                //deliveryStore.reset()

                if (!this.menu) return
                if (!this.menu.active) return

                let reset = !orderStore.state.order || this.menu.id !== orderStore.state.order.week_plan.id;

                if (reset) {
                    orderStore.updateOrderParam({ param: 'week_plan_id', value: this.menu.id })
                }

                if (orderStore.state.order.recipes.length === 0) {
                    // orderStore.updateOrderParam({ param: 'plan_id', value: plansStore.getPlan(this.getPeople(), this.getMeals()).id })
                }

                if (orderStore.state.order.recipes.length === 0 || reset) {
                    // orderStore.updateOrderParam({ param: 'recipes_id', value: this.recipesId })
                }

                orderStore.removeOrderParam({ param: 'shipment_zone_id' })
                orderStore.removeOrderParam({ param: 'shipment_day' })

                // TO DO this is temp 

                if (this.user && this.user.subscription && this.user.subscription.shipment_day === 0) {
                    orderStore.updateOrderParam({
                        param: 'shipment_day',
                        value: Object.values(this.menu.available).findIndex(r => r === true) + 1
                    })
                }

                return this.updateOrder()
             })

            .then(response => {
                this.$_deliveryContainer_fillSubscriptionParams()
            })

            .catch(response => {
                errorStore.formatMessage(response)
            })
        },

        getPeople () {
            var peopleDefault = 2
            if (this.$route.params.people) {
                return this.$route.params.people
            }
            if (container.get('services.cookies').get('_checkout_people', '/')) {
                return container.get('services.cookies').get('_checkout_people', '/')
            }
            return peopleDefault
        },

        getMeals () {
            var mealsDefault = 4
            if (this.$route.params.meals) {
                return this.$route.params.meals
            }
            if (container.get('services.cookies').get('_checkout_meals', '/')) {
                return container.get('services.cookies').get('_checkout_meals', '/')
            }
            return mealsDefault
        },

        updateOrder () {
            var params = this.orderStore.orderParams

                return orderStore.updateOrder()

            .then(response => {
                this.updateUserView()
                
                errorStore.removeMessage()
                this.loading['stop'] = false
            })
        },

        updateUserView () {
            var user = this.user
            if (user) user.subscription = this.subscriptionStore.subscription
            if (user) user.order = this.orderStore.order

            this.$root.updateUser(user)
        },  

        stepSubscription () {

            window.dispatchEvent(new CustomEvent('checkout-change-menu', { 
                bubbles: true,
                detail: () => {
                    this.stepStoreSubscription()
                }
            }));
        },

        stepStoreSubscription() {

            return stepStore.stepSubscription()

            .then(response => {
                orderStore.state.status = 'confirmed'
                stepStore.state.updating.subscription = false
                return orderStore.retrieveOrder()
            }).then(response => {
                this.updateUserView()

                stepStore.state.updating.subscription = false
                scrollToElementId("checkout-payment")
            })

            .catch(response => {
                stepStore.state.updating.subscription = false
                errorStore.formatMessage(response)

            })
        },

        stepPayment () {

            window.dispatchEvent(new CustomEvent('verify-page-confirmed', { 
                bubbles: true,
            }));

            errorStore.removeMessage()
        
            if (this.orderStore.status !== 'confirmed') {
                errorStore.updateMessage('Conferma i tuoi dati')
                return
            }

            return stepPaymentStore.stepPayment()

            .then(response => {
                if (this.stepPaymentStore.method === 'creditCard') this.$router.push({ name: 'thank-you-new' })
            })

            .catch(response => {
                errorStore.formatMessage(response)
                orderStore.retrieveOrder()
                stepPaymentStore.state.loading = false
            })
        },

        createGuest () {
            if (this.user) return Promise.resolve()
            return container.get('services.oauth').createGuest()
        },

        checkboxEvent (val) {
            errorStore.removeMessage()
            this.controller.paymentCheckbox = val

            if (!this.$mq.isDesktop() && val === true) {
                scrollToElementId('checkout-bill')
            }
        },

        afterload () {
            var error = this.$route.params.error
                ? this.$route.params.error
                : this.errorStore.message

            errorStore.updateMessage(error)

            this.hashHandler()
            this.scrollHandler()

        },

        eventStep(step) {
            window.dispatchEvent(new CustomEvent('quomi.event', { 
                bubbles: true, 
                detail: {
                  name: 'changeStep',
                  vars: {
                    step: step,
                    order: this.orderStore.order
                  }
                } 
            }));
         },

        addScrollListener () {
            this.$nextTick(() => {
                window.addEventListener('scroll', _ => {
                    var elem = document.getElementById('checkout-bill')
                    this.elemInView = elem && (window.scrollY >= elem.offsetTop - 150)
                })
            })
        }
    },

    mounted () {


        if (this.$route.params.people) container.get('services.cookies').set('_checkout_people', this.$route.params.people)
        if (this.$route.params.meals) container.get('services.cookies').set('_checkout_meals', this.$route.params.meals)


        if (this.$route.query.edenred) {
            this.updateStatus('confirmed')
            scrollToElementId("checkout-payment")
        }

        this.addScrollListener()

        this.load()

        .then(response => {
            return this.createNewOrder()
        })

        .then(response => {
            return this.afterload()
        })
        .then(response => {

        })

        .catch(response => {
            errorStore.formatMessage(response)
        })
    }
}
</script>

<style scoped>

.checkout-payoff {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 180px;
    margin: 20px auto;
}

h1 {
    position: relative;
    color: white;
    font-family: var(--quomi-cursive-font);
    text-shadow: 2px 2px 7px var(--quomi-darkgrey);
}

.container >>> h2 {
    margin: 0;
}

h4 {
    line-height: 1.5;
}

.subtitle {
    padding-top: 10px;
    position: relative;
    color: white;
    font-size: 17px;
    font-weight: 700;
    text-shadow: 2px 2px 7px var(--quomi-darkgrey);
    text-transform: none;
    letter-spacing: 0px;
}

section {
    padding: 0 0 50px 0;
}

.float {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
}

.container.bg {
    background-color: white;
}

.container {
    background-color: white;
    padding-bottom: 30px;
}

.small-text {
    font-size: 13px;
}

.info-banner {
    position: fixed;
    top: 80px;
    z-index: 4;
    background-color: white;
    border-bottom: 1px solid #ededed;
    width: 100%;
    padding-top: 2px;
    font-size: 13px;
    color: inherit;
    text-align: center;
    font-weight: 500;
}

.background {
    position: absolute;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    /**background: url('../../assets/img/covers/cover.jpg') top center no-repeat;*/
    background: white;
    background-size: cover;
}


.checkout-container {
    position: relative;
    max-width: 1200px;
    margin: 50px auto;
}

.border {
    border-bottom: 1px solid #ededed;
}
.checkout-container >>> section {
    border-bottom: 1px solid #ededed;
    padding: 20px 60px;
}

.checkout-container >>> section + .checkout-container >>> section {
    margin-top: -1px;
}

.checkout-panel {
    flex-basis: calc(100% - 400px);
    border-radius: 6px;
    background-color: white;
    align-self: flex-start; 
}

.container >>> .section-title:before {
    content: attr(data-step-number);
    border: 3px solid var(--quomi-darkgrey);
    flex-basis: 25px;
    min-width: 25px;
    height: 25px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -41px;
    margin-right: 15px;
    color: var(--quomi-darkgrey);
    font-weight: 700;
}

.container >>> .section-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.container >>> .section-content {
    margin: 20px 0;
}

.flex-right {
    text-align: right;
}

.container >>> [data-step-number="0"]:before {
    color: #fff;
    border-color: var(--quomi-primary);
    content: '\f00c';
    font-family: 'FontAwesome';
    background-color: var(--quomi-primary);
}

.sidebar-panel {
    padding-left: 25px;
    width: 400px;
    padding-bottom: 40px;
    position: relative;
}

.sidebar-panel_inner {
    border-radius: 6px;
    background-color: #fbf1d7;
    padding: 25px;
    min-height: 150px;
}

.footer-bill .btn >>> .loading {
    transform: translate(-50%, -50%) scale(0.7);
}

.footer-bill {
    position: fixed;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 4;
    border-top: 1px solid #ededed;
}

.footer-bill-inside {
    padding: 4px 10px;
    min-height: 70px;
}
.footer-bill-inside h3 {
    text-align: left;
    margin: 0;
    font-size: 16px;
}

.footer-bill-inside > div {
    width: 100%;
}

.footer-bill button,
.footer-bill .btn {
    background-color: var(--quomi-primary);
    color: white;
    padding: 10px 10px;
    width: 100%;
}

.icons {
    padding: 10px 0;
}

.tot-price {
    margin-right: 15px;
    font-size: 38px;
    font-weight: bold;
}

.tot-price.mobile,
.tot-price.mobile .new-price {
    font-size: 25px;
}

.new-price {
    font-size: 35px;
    color: red;
    line-height: 1.2;
}

.old-price {
    font-size: 15px;
    font-weight: normal;
}

@media (max-width: 1024px){
    .info-banner {
        top: 50px;
    }
    .container {
        padding-top: 50px;
        padding-bottom: 50px;
    }

    .checkout-panel{
        flex-basis: 100%;
        border-radius: 0;
    }

    .sidebar-panel {
        flex-basis: 100%;
        padding-top: 30px;
        padding-left: 0;
        margin: 0 20px 20px 20px;
    }

    .checkout-container {
        margin: 0 auto;
    }

    .checkout-container section {
        padding: 0 50px 0px 50px;
    }

    .container >>> .section-title {
        margin-right: -30px;
        flex-wrap: nowrap;
        align-items: flex-start;
    }

    .container >>> .section-title::before {
        margin-left: -35px;
    }

    .container >>> .section-title .flex-right {
        padding-left: 10px;
    }

    .container >>> .section-title h2 {
        text-align: left;
    }

    .container >>> .section-content {
        margin: 20px -30px;
    }
}

.gray {
  opacity: 0.7;
  font-size: 11px;
  line-height: 11px !important;
}
input.coupon {
    margin: 10px 0;
}


.conditions {
    margin: 10px 0 5px 0;
    cursor: pointer;
}

@media (max-width: 426px) {
    .checkout-container {
        top: -30px;
    }
}

</style>
